<template>
  <div class="pt-0 ptHeader mainBackVaillant widthFull mb-5 pt-5">
    <loading v-if="loadingState" />
   
    <div  class="container mt-5 pt-4">
      <!--   HEADER TITLE    ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
      <div class="row justify-content-center text-left">
        <h3 class="Regular center h0 widthFull"><b>Le tue pratiche </b></h3>
      </div>

      <div
        v-if="!presentPractices && hasPrev"
        class="row justify-content-center pb-5 pt-4 mt-5 vaillantCont"
      >
        <h4 class="black center widthFull mt-4">
          Non hai preventivi accettati
        </h4>
        <router-link class="btn btn-primary btn-lg btnYellow mt-2" to="/offerte"
          >Gestione Preventivi</router-link
        >
      </div>
      <div
        v-if="!presentPractices && !hasPrev"
        class="row justify-content-center pb-5 pt-4 mt-5 vaillantCont"
      >
        <h4 class="black center widthFull mt-4">
          Non creato ancora nessuna pratica
        </h4>
        <router-link
          class="btn btn-primary btn-lg btnYellow mt-2"
          to="/calcolatore"
          >Crea Pratica</router-link
        >
      </div>

      <div
        v-if="presentPractices"
        class="row justify-content-center pb-3 pt-3 align-items-end"
      >
        <div
          class="
            col-4 col-md-3
            pb-0
            pl-1
            pr-1
            pl-md-5
            pr-md-5
            d-none d-md-block
          "
        >
          <VueSvgGauge
            v-if="totCash"
            :start-angle="-90"
            :end-angle="90"
            :value="parseFloat(countCashClient)"
            :separator-step="step"
            :min="0"
            :innerRadius="70"
            :separatorThickness="1"
            :max="maxTotCash"
            :gauge-color="[
              { offset: 0, color: '#f39324' },
              { offset: 100, color: '#00897e' },
            ]"
            :scale-interval="100"
          >
            <div class="gaugeText">
              <p class="widhtFull pt-5 mt-2">€</p>
              <p class="widhtFull">
                <b>{{ countCashClient | formatNumber }}</b>
              </p>
              <p class="widhtFull"><small>Fatturato verso Clienti</small></p>
            </div>
          </VueSvgGauge>
        </div>

        <div class="col-5 col-md-3 pb-0 pr-0 pl-0">
          <VueSvgGauge
            v-if="totCash"
            :start-angle="-90"
            :end-angle="90"
            :value="parseFloat(countCashInst)"
            :separator-step="step"
            :min="0"
            :innerRadius="70"
            :separatorThickness="1"
            :max="maxTotCash"
            :gauge-color="[
              { offset: 0, color: '#f39324' },
              { offset: 100, color: '#00897e' },
            ]"
            :scale-interval="100"
          >
            <div class="gaugeText">
              <p class="widhtFull pt-5 mt-2">€</p>
              <p class="widhtFull">
                <b>{{ countCashInst | formatNumber }}</b>
              </p>
              <p class="widhtFull"><small>Credito Totale</small></p>
            </div>
          </VueSvgGauge>
        </div>

        <div
          class="
            col-4 col-md-3
            center
            pl-1
            pr-1
            pl-md-5
            pr-md-5
            d-none d-md-block
          "
        >
          <VueSvgGauge
            v-if="totCash"
            :start-angle="-90"
            :end-angle="90"
            :value="parseFloat(countCashClient) + parseFloat(countCashInst)"
            :separator-step="step"
            :min="0"
            :innerRadius="70"
            :separatorThickness="1"
            :max="maxTotCash"
            :gauge-color="[
              { offset: 0, color: '#f39324' },
              { offset: 100, color: '#00897e' },
            ]"
            :scale-interval="100"
          >
            <div class="gaugeText">
              <p class="widhtFull pt-5 mt-2">€</p>
              <p class="widhtFull">
                <b>{{
                  (parseFloat(countCashClient) + parseFloat(countCashInst))
                    | formatNumber
                }}</b>
              </p>
              <p class="widhtFull"><small>Fatturato Totale</small></p>
            </div>
          </VueSvgGauge>
        </div>

        <div class="col-6 col-md-3">
          <form v-on:submit.prevent="filterValues">
            <h5 class="text-center grey pb-0 mb-0">Ricerca Pratica</h5>
            <div class="input-group mb-0">
              <input
                type="text"
                v-model="filter"
                class="form-control seachMobButton"
                placeholder="Numero Pratica o Cognome..."
              />
              <div class="input-group-append d-none">
                <button
                  class="btn btn-outline-secondary"
                  v-on:click.prevent="filterValues"
                  type="button"
                >
                  CERCA
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div
        v-if="presentPractices && hasPrev"
        class="
          row
          mr-0
          ml-0
          justify-content-center
          pb-0
          pt-0
          align-items-end
          bgWhite
          mb-3
        "
      >
        <div class="col-6 col-md-3 center Bold">
          <h5>
            <b>{{ totUserReceived | formatNumber }} €</b>
          </h5>
          <p>Credito Ceduto*</p>
        </div>

        <div class="col-6 col-md-3 center Bold">
          <h5>
            <b>{{ totAmountBefore10 | formatNumber }} €</b>
          </h5>
          <p>Credito in maturazione</p>
        </div>

        <div class="col-6 col-md-3 center Bold">
          <h5>
            <b>{{ totAmountAfter10 | formatNumber }} €</b>
          </h5>
          <p>Credito Cedibile*</p>
        </div>

        <div class="col-6 col-md-3 Bold">
          <p>
            * Il valore del credito cedibile e il valore del credito ceduto sono
            aggiornati agli ultimi 10 giorni
          </p>
        </div>
      </div>

      <div
        v-if="presentPractices"
        class="row justify-content-center align-items-end mt-5"
      >
        <!--  -->

        <div class="col-4 col-md-2 text-center text-md-left">
          <!--
      <div class="buttonTextCont widthfull lightRight">
        <p class="widthFull pb-0 mb-0">Pratiche: {{countErrorPractice}}</p>
        <p class="widthFull pb-0 mb-0">Fatturato: € {{totErrorCashClient | formatNumber}}</p>
        <p class="widthFull pb-0 mb-0">Da Cessione: € {{totErrorCashInst | formatNumber}}</p>
      </div>
    -->

          <div class="buttonTextCont widthfull lightRight">
            <h1 class="widthFull mt-0 center pb-0 mb-0">
              <b>{{ countErrorPractice }}</b>
            </h1>
            <!--<p class="widthFull center pb-0 mb-0">Pratic<span v-if="countErrorPractice == 1">a</span> <span v-else>he</span> </p>-->
          </div>

          <a
            class="btn btn-danger btn-sm uppercase widthFull"
            v-on:click="filter = 'Pratiche con Anomalie'"
          >
            <font-awesome-icon icon="exclamation-triangle" size="sm" /><span
              class="d-none d-md-inline"
            >
              Con Anomalie</span
            >
          </a>
        </div>

        <div class="col-4 col-md-2 text-left text-center text-md-left">
          <!--
        <div class="buttonTextCont widthfull">
          <p class="widthFull pb-0 mb-0">Pratiche: {{countPractices}}</p>
          <p class="widthFull pb-0 mb-0">Fatturato: € {{countCashClient | formatNumber}}</p>
          <p class="widthFull pb-0 mb-0">Da Cessione: € {{countCashInst | formatNumber}}</p>
        </div>
      -->

          <div class="buttonTextCont widthfull lightGreen">
            <h1 class="widthFull mt-0 center pb-0 mb-0">
              <b>{{ countPractices }}</b>
            </h1>
            <!--<p class="widthFull center pb-0 mb-0">Pratic<span v-if="countPractices == 1">a</span> <span v-else>he</span> </p>-->
          </div>

          <a
            class="btn btn-primary btn-blue btn-sm uppercase widthFull"
            v-on:click="filter = ''"
          >
            <font-awesome-icon class="white" icon="clipboard-list" size="sm" />
            <span class="d-none d-md-inline white"> Tutte le pratiche</span>
          </a>
        </div>

        <div class="col-4 col-4 col-md-2 text-center text-md-left">
          <!--
        <div class="buttonTextCont widthfull">
          <p class="widthFull pb-0 mb-0">Pratiche: {{countStep1Practice}}</p>
          <p class="widthFull pb-0 mb-0">Fatturato: € {{totStep1CashClient | formatNumber}}</p>
          <p class="widthFull pb-0 mb-0">Da Cessione: € {{totStep1CashInst | formatNumber}}</p>
        </div>

      -->

          <div class="buttonTextCont widthfull">
            <h1 class="widthFull mt-0 center pb-0 mb-0">
              <b>{{ countStep1Practice }}</b>
            </h1>
            <!--  <p class="widthFull center pb-0 mb-0">Pratic<span v-if="countStep1Practice == 1">a</span> <span v-else>he</span> </p>-->
          </div>

          <a
            class="btn btn-info btn-sm uppercase widthFull"
            v-on:click="filter = 'Step1'"
          >
            <font-awesome-icon icon="balance-scale" size="sm" />
            <span class="d-none d-md-inline"> Carica Docum...</span>
          </a>
        </div>
        <div class="col-4 col-md-2 text-left">
          <!--
        <div class="buttonTextCont widthfull">
          <p class="widthFull pb-0 mb-0">Pratiche: {{countStep2Practice}}</p>
          <p class="widthFull pb-0 mb-0">Fatturato: € {{totStep2CashClient | formatNumber}}</p>
          <p class="widthFull pb-0 mb-0">Da Cessione: € {{totStep2CashInst | formatNumber}}</p>
        </div>
      -->

          <div class="buttonTextCont widthfull">
            <h1 class="widthFull mt-0 center pb-0 mb-0">
              <b>{{ countStep2Practice }}</b>
            </h1>
            <!--  <p class="widthFull center pb-0 mb-0">Pratic<span v-if="countStep2Practice == 1">a</span> <span v-else>he</span> </p>-->
          </div>

          <a
            class="btn btn-primary btn-sm uppercase widthFull"
            v-on:click="filter = 'Step2'"
          >
            <font-awesome-icon icon="balance-scale" class="white" size="sm" />
            <span class="d-none d-md-inline white"> Verifica</span>
          </a>
        </div>
        <div class="col-4 col-md-2 text-left">
          <!--
        <div class="buttonTextCont widthfull">
          <p class="widthFull pb-0 mb-0">Pratiche: {{countStep3Practice}}</p>
          <p class="widthFull pb-0 mb-0">Fatturato: € {{totStep3CashClient | formatNumber}}</p>
          <p class="widthFull pb-0 mb-0">Da Cessione: € {{totStep3CashInst | formatNumber}}</p>
        </div>
      -->
          <div class="buttonTextCont widthfull">
            <h1 class="widthFull mt-0 center pb-0 mb-0">
              <b>{{ countStep3Practice }}</b>
            </h1>
            <!--<p class="widthFull center pb-0 mb-0">Pratic<span v-if="countStep3Practice == 1">a</span> <span v-else>he</span> </p>-->
          </div>

          <a
            class="btn btn-primary btn-sm widthFull"
            v-on:click="filter = 'Step3'"
          >
            <font-awesome-icon icon="balance-scale" class="white" size="sm" />
            <span class="d-none d-md-inline white">
              richiesta a A<span style="text-transform: lowercase !important"
                >d</span
              >E</span
            >
          </a>
        </div>
        <div class="col-4 col-md-2 text-left">
          <!--
        <div class="buttonTextCont widthfull">
          <p class="widthFull pb-0 mb-0">Pratiche: {{countStep4Practice}}</p>
          <p class="widthFull pb-0 mb-0">Fatturato: € {{totStep4CashClient | formatNumber}}</p>
          <p class="widthFull pb-0 mb-0">Da Cessione: € {{totStep4CashInst | formatNumber}}</p>
        </div>
      -->

          <div class="buttonTextCont widthfull">
            <h1 class="widthFull mt-0 center pb-0 mb-0">
              <b>{{ countStep4Practice }}</b>
            </h1>
            <!--<p class="widthFull center pb-0 mb-0">Pratic<span v-if="countStep4Practice == 1">a</span> <span v-else>he</span> </p>-->
          </div>

          <a
            class="btn btn-primary btn-sm uppercase btn-blue widthFull"
            v-on:click="filter = 'Step4'"
          >
            <font-awesome-icon icon="euro-sign" size="sm" class="white" />
            <span class="d-none d-md-inline white"> BONIFICO </span>
          </a>
        </div>
      </div>

      <div class="row justify-content-center pb-5">
        <div v-if="!showFilterText" class="col-md-12 col-lg-12">
          <badger-accordion key="sdfg345" class="pb-5 mt-4">
            <badger-accordion-item
              v-for="(item, key) in practicesFiltred"
              class=""
              :key="item.code + '_' + countloop"
              v-if="item.status != 10"
            >
              <template slot="header" class="center">
                <div class="row justify-content-center">
                  <div class="col-md-9 text-center text-md-left">
                    <h5 class="black">
                      Pratica associata a
                      <b class="underline">{{ item.azienda_user }}</b> con PIVA
                      <b class="underline">{{ item.partita_iva_user }} </b>
                    </h5>
                    <h5 class="black">
                      N. <b class="underline">{{ item.code }}</b> del
                      {{ moment(item.created_at).format("DD-MM-YYYY HH:mm") }} (
                      {{ item.bonus }} ) per
                      <b> {{ item.client_name }} {{ item.client_lastname }} </b>
                    </h5>
                    <a
                      v-if="hasPrev"
                      class="btn btn-primary m-2 btn-sm"
                      :href="item.signed_order"
                      target="_blank"
                    >
                      <font-awesome-icon icon="eye" size="sm" /> visualizza
                      Preventivo Firmato
                    </a>

                    <router-link
                      :to="{ name: 'loadDocuments', params: { item: item } }"
                      class="btn btn-primary btn-blue m-2 btn-sm"
                    >
                      <font-awesome-icon icon="clipboard-check" size="1x" />
                      Gestione Documenti
                    </router-link>

                    <button
                      type="button"
                      v-if="item.status == 1 && item.payment_id == '0'"
                      class="btn btn-danger m-2 btn-sm"
                      v-on:click="removePractice(item.id, item.code, key)"
                    >
                      <font-awesome-icon icon="trash-alt" size="sm" /> Elimina
                    </button>

                    <img
                      v-if="item.status == 1"
                      class="img-fluid widthFull traficLight maxBomTr2 ml-md-5"
                      src="../../assets/images/traficLight_red.png"
                    />
                    <img
                      v-if="
                        item.status == 2 || item.status == 3 || item.status == 4
                      "
                      class="img-fluid widthFull traficLight maxBomTr2 ml-md-5"
                      src="../../assets/images/traficLight_yellow.png"
                    />
                    <img
                      v-if="item.status == 5"
                      class="img-fluid widthFull traficLight maxBomTr2 ml-md-5"
                      src="../../assets/images/traficLight_green.png"
                    />
                  </div>

                  <div class="col-7 col-md-1 center pl-md-0 pr-md-0 pt-3">
                    <img
                      v-if="item.enea_request == '1'"
                      class="img-fluid widthFull mt-2"
                      :class="{
                        'bg-success': checkEneaComplate(
                          item.aditional_enea_data
                        ),
                      }"
                      src="../../assets/images/enea.png"
                    />
                    <img
                      v-if="item.to_get_cadastral_data == '1'"
                      class="img-fluid widthFull mt-2"
                      :class="{ 'bg-success': item.dcast_export == '10' }"
                      src="../../assets/images/dcast.png"
                    />
                  </div>

                  <div class="col-md-2 center pt-3">
                    <span
                      v-if="item.status == 1"
                      class="
                        inline-block
                        center
                        relative
                        topCust2
                        d-none d-md-inline
                      "
                      style="position: initial !important"
                    >
                      <img class="qrcodeImg qrcodeImg2" :src="item.qrcode" />
                      <br />
                    </span>

                    <span
                      v-if="item.status != 1 && item.ade_protocol_number"
                      class="
                        inline-block
                        center
                        relative
                        topCust2
                        d-md-inline
                        pt-4 pt-md-0
                        pb-0
                      "
                      style="position: initial !important"
                    >
                      <p class="pt-0 pt-md-2 pb-md-2 bgGreen white">
                        <small
                          ><b
                            >Protocollo AdE nr.
                            {{ item.ade_protocol_number }}</b
                          ></small
                        >
                      </p>
                    </span>
                  </div>
                  <!--
                <div class="col-md-1">
                  <a class="greenLinkAccordion2 Regular d-none d-md-block">Dettagli</a>
                </div>
              -->

                  <div
                    v-if="item.status == 1 && item.hasErrors == 'no'"
                    class="col-11 col-md-11 mt-3 center requiredCont"
                  >
                    <h5 class="yellow widthFull text-left">
                      <b class="mr-4 theme">Per procedere:</b>
                      <span class="theme">
                        Prepara e carica tutta la documentazione nella sezione
                        GESTIONE DOCUMENTI
                      </span>
                    </h5>
                  </div>

                  <!-- ENEA DOCUMENTS REQUEST -->
                  <div
                    v-if="
                      item.aditional_enea_data == null &&
                      item.enea_request == '1' &&
                      item.payment_id != '0' && 2==3
                    "
                    class="col-md-11 requiredCont"
                  >
                    <h5 class="Regular text-center h0 widthFull">
                      <b v-if="item.status == 2"
                        ><span class="yellow">Attenzione!</span> Per redigere e
                        inviare la Pratica ENEA abbiamo necessità di ulteriori
                        informazioni
                      </b>
                      <b v-else
                        ><span class="yellow">Attenzione!</span> Per redigere ed
                        inviare la pratica ENEA avremo bisogno di ulteriori
                        informazioni che ti chiederemo alla conclusione del Set
                        Documentale.
                      </b>

                      <router-link
                        v-if="item.status == 2"
                        :to="{
                          name: 'complateEneaData',
                          params: { item: item },
                        }"
                        class="btn btn-primary m-2 btn-sm"
                      >
                        Inserisci
                      </router-link>
                    </h5>
                  </div>
                  <!-- END DOCUMENTS REQUEST -->

                  <div
                    v-if="item.hasErrors == 'yes'"
                    class="col-11 col-md-11 mt-3 center requiredCont"
                  >
                    <h5 class="red widthFull text-left">
                      <b class="widthFull mr-4"
                        >Attenzione abbiamo rilevato seguenti anomalie:</b
                      >
                    </h5>

                    <h5 class="red widthFull text-left pl-4">
                      {{ item.errors }}
                    </h5>
                  </div>

                  <div class="col-md-12 center pt-4">
                    <div class="card step-progress pt-3">
                      <div class="step-slider">
                        <div
                          data-id="step1"
                          v-on:click="
                            $router.push({
                              name: 'loadDocuments',
                              params: { item: item },
                            })
                          "
                          class="step-slider-item"
                          :class="{
                            active: item.status == 1,
                            'active passed': item.status != 1,
                          }"
                        >
                          <span class="stTitle"
                            >Step 1 <br />
                            <b>Carica Documentazione</b></span
                          >
                        </div>
                        <div
                          data-id="step2"
                          class="step-slider-item"
                          :class="{
                            notactive: item.status == 1,
                            active: item.status == 2,
                            'active passed':
                              item.status != 1 && item.status != 2,
                          }"
                        >
                          <span class="stTitle"
                            >Step 2 <br />
                            <b>Verifica</b></span
                          >
                        </div>
                        <div
                          data-id="step3"
                          class="step-slider-item notactive"
                          :class="{
                            notactive: item.status == 2,
                            active: item.status == 3,
                            'active passed':
                              item.status != 1 &&
                              item.status != 2 &&
                              item.status != 3,
                          }"
                        >
                          <span class="stTitle"
                            >Step 3 <br />
                            <b>Accettazione cessione del credito</b>
                          </span>
                        </div>
                        <div
                          data-id="step4"
                          class="step-slider-item notactive"
                          :class="{
                            notactive: item.status == 3,
                            active: item.status == 4,
                            'active passed':
                              item.status != 1 &&
                              item.status != 2 &&
                              item.status != 3 &&
                              item.status != 4,
                          }"
                        >
                          <span class="stTitle"
                            >Step 4 <br />
                            <b> Bonifico</b></span
                          >
                        </div>
                      </div>
                      <div class="step-content"></div>
                    </div>
                  </div>
                </div>
              </template>
              <template slot="content" class="bbaLightColor">
                <div class="row justify-content-center pb-2 pl-md-3 pr-md-3">
                  <div
                    class="text-left"
                    :class="{ 'col-11': !hasPrev, 'col-md-9': hasPrev }"
                  >
                    <h5 class="black">
                      Indirizzo dell'immobile
                      <b
                        >{{ item.building_address }} {{ item.building_civic }} -
                        {{ item.building_zip }} {{ item.building_city }} ({{
                          item.building_province
                        }})
                      </b>
                    </h5>
                  </div>

                  <div v-if="hasPrev" class="col-md-3 text-left">
                    <h5 class="black pb-0">Dati dell'intervento</h5>
                    Tipo:
                    <b
                      ><span class="uppercase Regular">{{
                        item.intervention_type
                      }}</span></b
                    >
                  </div>

                  <div v-if="hasPrev" class="col-md-3 text-left">
                    <h5 class="black pb-0 text-left widthFull">
                      Da Cliente:
                      <b>
                        €
                        {{
                          parseFloat(item.total_transfer_for_client)
                            | formatNumber
                        }}</b
                      >
                    </h5>
                  </div>

                  <div v-if="hasPrev" class="col-md-3 text-left">
                    <h5 class="black pb-0 text-left">
                      Da Cessione:
                      <b>
                        €
                        {{
                          parseFloat(item.total_transfer_for_user)
                            | formatNumber
                        }}</b
                      >
                    </h5>
                  </div>

                  <div v-if="hasPrev" class="col-md-3 text-left">
                    <h5 class="black pb-0 text-left">
                      Totale:
                      <b>
                        €
                        {{
                          (parseFloat(item.total_transfer_for_client) +
                            parseFloat(item.total_transfer_for_user))
                            | formatNumber
                        }}</b
                      >
                    </h5>
                  </div>
                  <!--
                <div class="col-md-3 text-left">
                  <h5 class="black pb-0"> <b>Data:</b>
                    <span class="uppercase">{{moment(item.intervention_date).format('DD-MM-YYYY')}}</span>
                  </h5>
                </div>
              -->
                </div>
              </template>
            </badger-accordion-item>
          </badger-accordion>

          <badger-accordion class="pb-5 mt-4" key="12312412512354134">
            <badger-accordion-item
              class=""
              :id="'id_closed'"
              v-if="hasRemovedPractics && filter == ''"
            >
              <template slot="header" class="center">
                <h5 v-if="hasRemovedPractics" class="text-left black">
                  Pratiche Eliminate
                </h5>
                <p v-if="hasRemovedPractics" class="text-left black">
                  Attenzione! i dati della dashboard non includono il valori di
                  pratiche eliminate.
                </p>
              </template>
              <template slot="content" class="bbaLightColor">
                <badger-accordion class="pb-5 mt-4 greyBg">
                  <badger-accordion-item
                    v-for="(item, key) in practicesFiltred"
                    :key="item.code + '12'"
                    class="greyBg"
                    v-if="item.status == 10"
                  >
                    <template slot="header" class="greyBg">
                      <div class="row justify-content-center">
                        <div class="col-md-9 text-center text-md-left">
                          <h5 class="black">
                            Pratica N.
                            <b class="underline">{{ item.code }}</b> del
                            {{
                              moment(item.created_at).format("DD-MM-YYYY HH:mm")
                            }}
                            ( {{ item.bonus }} ) per
                            <b>
                              {{ item.client_name }} {{ item.client_lastname }}
                            </b>
                          </h5>
                          <a
                            class="btn btn-primary m-2 btn-sm"
                            :href="item.signed_order"
                            target="_blank"
                          >
                            <font-awesome-icon icon="eye" size="sm" />
                            visualizza Preventivo Firmato
                          </a>
                        </div>
                        <div class="col-md-3 center pt-3"></div>
                        <!--
              <div class="col-md-1">
                <a class="greenLinkAccordion2 Regular d-none d-md-block">Dettagli</a>
              </div>
            -->
                      </div>
                    </template>
                    <template slot="content" class="greyBg">
                      <div
                        class="row justify-content-center pb-2 pl-md-3 pr-md-3"
                      >
                        <div class="col-md-9 text-left">
                          <h5 class="black">
                            Indirizzo dell'immobile
                            <b
                              >{{ item.building_address }}
                              {{ item.building_civic }} -
                              {{ item.building_zip }}
                              {{ item.building_city }} ({{
                                item.building_province
                              }})
                            </b>
                          </h5>
                        </div>

                        <div class="col-md-3 text-left">
                          <h5 class="black pb-0">Dati dell'intervento</h5>
                          Tipo:
                          <b
                            ><span class="uppercase Regular">{{
                              item.intervention_type
                            }}</span></b
                          >
                        </div>

                        <div class="col-md-3 text-left">
                          <h5 class="black pb-0 text-left widthFull">
                            Da Cliente:
                            <b>
                              €
                              {{
                                parseFloat(item.total_transfer_for_client)
                                  | formatNumber
                              }}</b
                            >
                          </h5>
                        </div>

                        <div class="col-md-3 text-left">
                          <h5 class="black pb-0 text-left">
                            Da Cessione:
                            <b>
                              €
                              {{
                                parseFloat(item.total_transfer_for_user)
                                  | formatNumber
                              }}</b
                            >
                          </h5>
                        </div>

                        <div class="col-md-3 text-left">
                          <h5 class="black pb-0 text-left">
                            Totale:
                            <b>
                              €
                              {{
                                (parseFloat(item.total_transfer_for_client) +
                                  parseFloat(item.total_transfer_for_user))
                                  | formatNumber
                              }}</b
                            >
                          </h5>
                        </div>

                        <div class="col-md-3 text-left">
                          <h5 class="black pb-0">
                            <b>Data:</b>
                            <span class="uppercase">{{
                              moment(item.intervention_date).format(
                                "DD-MM-YYYY"
                              )
                            }}</span>
                          </h5>
                        </div>
                      </div>
                    </template>
                  </badger-accordion-item>
                </badger-accordion>
              </template>
            </badger-accordion-item>
          </badger-accordion>
        </div>

        <div v-else class="col-md-12 col-lg-12 vaillantCont mt-4 pt-5 pb-5">
          <h5 class="center">Nessun risultato per {{ filter }}</h5>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { AUTH_REQUEST, AUTH_SOCIAL } from "actions/auth";
import { mapGetters, mapState } from "vuex";
import axios from "axios";
import { BadgerAccordion, BadgerAccordionItem } from "vue-badger-accordion";

import { VueSvgGauge } from "vue-svg-gauge";

const moment = require("moment");

export default {
  name: "Practics",
  components: {
    BadgerAccordion,
    BadgerAccordionItem,
    VueSvgGauge,
  },
  data() {
    return {
      token: "",
      corporateClient: "",
      loadingState: false,
      loading: false,
      practices: {},
      countloop: 1,
      moment: require("moment"),
      presentPractices: true,
      countPractices: 0,
      countCashClient: 0,
      countCashInst: 0,
      practicesFiltred: {},
      filter: "",
      presentPractices: true,
      moment: require("moment"),
      maxTotCash: 1000000,
      totCash: 0,
      step: 1000,
      hasPrev: false,
      showFilterText: false,
      // COUNTS
      // ERROR
      countErrorPractice: 0,
      totErrorCashClient: 0,
      totErrorCashInst: 0,
      // STEP 1
      countStep1Practice: 0,
      totStep1CashClient: 0,
      totStep1CashInst: 0,
      // STEP 2
      countStep2Practice: 0,
      totStep2CashClient: 0,
      totStep2CashInst: 0,
      // STEP 3
      countStep3Practice: 0,
      totStep3CashClient: 0,
      totStep3CashInst: 0,
      // STEP 4
      countStep4Practice: 0,
      totStep4CashClient: 0,
      totStep4CashInst: 0,

      totUserReceived: 0,
      totAmountBefore10: 0,
      totAmountAfter10: 0,

      hasRemovedPractics: false,
    };
  },
  methods: {
    checkEneaComplate(val) {
      if (val) {
        if (val.includes('"status":"success"')) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    async getPractices() {
      var _vue = this;

      _vue.totUserReceived = this.adminIs
        ? _vue.getProfile.total_bonus_received
        : "";

      this.loadingState = true;

      var token = !this.adminIs ? _vue.getProfile.userToken : this.AdminId;

      if (token) {
        var data = {
          type: "all",
          user_token: token,
          call: this.adminIs,
        };
        data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
        await axios({
          url: process.env.ROOT_API + "api/getPractices",
          method: "POST",
          data: { data },
          headers: {
            Authorization: "Bearer " + process.env.AUTH_TOKEN,
            "Content-type": "application/json",
          },
        })
          .then((resp) => {
            resp.data = this.$decryptByAES(resp.data, process.env.CRYPTKEY);
            _vue.practices = resp.data.practices;

            this.$log(_vue.practices);

            _vue.totCash = 0;
            _vue.countPractices = 0;
            _vue.countCashInst = 0;
            _vue.countCashClient = 0;

            // ERRORS
            _vue.countErrorPractice = 0;
            _vue.totErrorCashClient = 0;
            _vue.totErrorCashInst = 0;
            // STEP 1
            _vue.countStep1Practice = 0;
            _vue.totStep1CashClient = 0;
            _vue.totStep1CashInst = 0;
            // STEP 2
            _vue.countStep2Practice = 0;
            _vue.totStep2CashClient = 0;
            _vue.totStep2CashInst = 0;
            // STEP 3
            _vue.countStep3Practice = 0;
            _vue.totStep3CashClient = 0;
            _vue.totStep3CashInst = 0;
            // STEP 4
            _vue.countStep4Practice = 0;
            _vue.totStep4CashClient = 0;
            _vue.totStep4CashInst = 0;

            // NEWWWWWW

            for (var x in _vue.practices) {
              if (_vue.practices[x].status != "10") {
                _vue.countPractices++;
                _vue.totCash = (
                  parseFloat(_vue.totCash) +
                  parseFloat(_vue.practices[x].total_work_and_iva)
                ).toFixed(2);
                //_vue.countCashInst = (parseFloat(_vue.countCashInst) + parseFloat(_vue.practices[x].total_transfer_for_user)).toFixed(2)
                _vue.countCashInst = (
                  parseFloat(_vue.countCashInst) +
                  parseFloat(_vue.practices[x].total_bonus_savings)
                ).toFixed(2);

                // NEWWWWWW

                _vue.totAmountBefore10 = (
                  parseFloat(_vue.totAmountBefore10) +
                  parseFloat(_vue.practices[x].amount_before_10)
                ).toFixed(2);
                _vue.totAmountAfter10 = (
                  parseFloat(_vue.totAmountAfter10) +
                  parseFloat(_vue.practices[x].amount_after_10)
                ).toFixed(2);

                _vue.countCashClient = (
                  parseFloat(_vue.countCashClient) +
                  parseFloat(_vue.practices[x].total_transfer_for_client)
                ).toFixed(2);
                this.$log(1);
                if (_vue.practices[x].hasErrors == "yes") {
                  this.$log(22);
                  _vue.countErrorPractice = _vue.countErrorPractice + 1;
                  _vue.totErrorCashClient = (
                    parseFloat(_vue.countErrorPractice) +
                    parseFloat(_vue.practices[x].total_transfer_for_client)
                  ).toFixed(2);
                  _vue.totErrorCashInst = (
                    parseFloat(_vue.totErrorCashInst) +
                    parseFloat(_vue.practices[x].total_transfer_for_user)
                  ).toFixed(2);
                }

                if (_vue.practices[x].status == "1") {
                  _vue.countStep1Practice = _vue.countStep1Practice + 1;
                  _vue.totStep1CashClient = (
                    parseFloat(_vue.countStep1Practice) +
                    parseFloat(_vue.practices[x].total_transfer_for_client)
                  ).toFixed(2);
                  _vue.totStep1CashInst = (
                    parseFloat(_vue.totStep1CashInst) +
                    parseFloat(_vue.practices[x].total_transfer_for_user)
                  ).toFixed(2);
                }

                if (_vue.practices[x].status == "2") {
                  _vue.countStep2Practice = _vue.countStep2Practice + 1;
                  _vue.totStep2CashClient = (
                    parseFloat(_vue.countStep2Practice) +
                    parseFloat(_vue.practices[x].total_transfer_for_client)
                  ).toFixed(2);
                  _vue.totStep2CashInst = (
                    parseFloat(_vue.totStep2CashInst) +
                    parseFloat(_vue.practices[x].total_transfer_for_user)
                  ).toFixed(2);
                }

                if (_vue.practices[x].status == "3") {
                  _vue.countStep3Practice = _vue.countStep3Practice + 1;
                  _vue.totStep3CashClient = (
                    parseFloat(_vue.countStep3Practice) +
                    parseFloat(_vue.practices[x].total_transfer_for_client)
                  ).toFixed(2);
                  _vue.totStep3CashInst = (
                    parseFloat(_vue.totStep3CashInst) +
                    parseFloat(_vue.practices[x].total_transfer_for_user)
                  ).toFixed(2);
                }

                if (_vue.practices[x].status == "4") {
                  _vue.countStep4Practice = _vue.countStep4Practice + 1;
                  _vue.totStep4CashClient = (
                    parseFloat(_vue.countStep4Practice) +
                    parseFloat(_vue.practices[x].total_transfer_for_client)
                  ).toFixed(2);
                  _vue.totStep4CashInst = (
                    parseFloat(_vue.totStep4CashInst) +
                    parseFloat(_vue.practices[x].total_transfer_for_user)
                  ).toFixed(2);
                }
              }

              if (_vue.practices[x].status == "10") {
                _vue.hasRemovedPractics = true;
              }

              this.$log(333);
            }

            _vue.totAmountAfter10 = (
              parseFloat(_vue.totAmountAfter10) -
              parseFloat(_vue.totUserReceived)
            ).toFixed(2);

            this.totCash = parseFloat(this.totCash);
            if (this.totCash < 10000) {
              this.maxTotCash = 10000;
              this.step = 1000;
            } else if (this.totCash < 100000) {
              this.maxTotCash = 100000;
              this.step = 10000;
            } else if (this.totCash < 1000000) {
              this.maxTotCash = 1000000;
              this.step = 100000;
            } else if (this.totCash < 100000000) {
              this.maxTotCash = 100000000;
              this.step = 1000000;
            }
            _vue.practicesFiltred = _vue.practices;
            this.$warn(_vue.practicesFiltred);

            this.$log(4444);

            _vue.loadingState = false;
          })
          .catch((resp) => {
            this.$log("errrrrrrrrrrrrrrrrrrrrrrrroooooooooooooooooooooor");
            (_vue.presentPractices = false), (_vue.loadingState = false);
          });
      }
    },
    showAlert() {
      // Use sweetalret2
      this.$swal({
        type: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    },
    filterValues() {
      var text = this.filter.toLowerCase();
      this.showFilterText = false;
      this.$log(text);
      var bank = {};
      var z = 0;

      Object.assign(this.practicesFiltred, {});

      if (
        text == "step1" ||
        text == "step2" ||
        text == "step3" ||
        text == "step4"
      ) {
        for (var x in this.practices) {
          if (
            this.practices[x].status.toLowerCase() == text.replace("step", "")
          ) {
            bank[x] = this.practices[x];
            z = z + 1;
          }
        }
      } else if (text == "pratiche con anomalie") {
        for (var x in this.practices) {
          if (this.practices[x].hasErrors == "yes") {
            bank[x] = this.practices[x];
            z = z + 1;
          }
        }
      } else {
        for (var x in this.practices) {
          this.$log(this.practices[x].hasErrors);
          if (
            (this.practices[x].code.toLowerCase().includes(text) ||
              this.practices[x].client_lastname.toLowerCase().includes(text) ||
              this.practices[x].azienda_user.toLowerCase().includes(text) ||
              this.practices[x].partita_iva_user.toLowerCase().includes(text) ||
              this.practices[x].client_name.toLowerCase().includes(text) ||
              this.practices[x].building_city.toLowerCase().includes(text)) &&
            this.practices[x].status != "10"
          ) {
            bank[x] = this.practices[x];
            z = z + 1;
          }
        }
      }
      this.countloop = this.countloop + 1;
      this.$log(z);
      this.$log(bank);
      this.practicesFiltred = bank;

      if (z == 0) {
        this.showFilterText = true;
      } else {
        this.showFilterText = false;
      }
    },
    removePractice(id, code, key) {
      var id_order = id;
      var _vue = this;

      this.$swal({
        title: "Attenzione!",
        type: "warning",
        html:
          "<br/>Sei sicuro di voler eliminare Pratica N. " +
          code +
          "?<br/><br/>",
        showCancelButton: true,
        confirmButtonText: `SI`,
        cancelButtonText: `NO`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        this.$log(result);
        if (result.value) {
          var data= {
              id: id,
              user_token: _vue.getProfile.userToken,
              status: 10,
            }
           data = this.$encryptByAES(JSON.stringify(data), process.env.CRYPTKEY);
          axios({
            url: process.env.ROOT_API + "api/changeOrderState",
            method: "POST",
            data:{data},
            headers: {
              Authorization: "Bearer " + process.env.AUTH_TOKEN,
              "Content-type": "application/json",
            },
          })
            .then((resp) => {
              _vue.getPractices();
              _vue.$swal(
                "Pratica N. " + code + " <br/>è stato eliminata ",
                "",
                "success"
              );
            })
            .catch((resp) => {
              _vue.$swal("Ops. Riprova piu tardi", "", "error");
            });
        }
      });
    },

    async checkBonusValues() {
      var _vue = this;
      this.loadingState = true;
      var token = !this.adminIs ? _vue.getProfile.userToken : this.AdminId;
      await axios({
        url: process.env.ROOT_API + "api/checkBonusValues",
        method: "POST",
        data: {
          user_token: token,
          call: this.adminIs,
        },
        headers: {
          Authorization: "Bearer " + process.env.AUTH_TOKEN,
          "Content-type": "application/json",
        },
      })
        .then((resp) => {
          this.loadingState = false;
        })
        .catch((resp) => {
          this.loadingState = false;
        });
    },
    setProfile: function () {
      //type 1 => no preventivatore
      if (this.profile.type == 1) {
        this.hasPrev = false;
      }
      if (this.profile.status == "admin") {
        this.adminIs = true;
        this.AdminId = this.profile.id;
        this.flagForCheck = this.profile.type;
      } else if (this.profile.status == "user") {
        this.adminIs = false;
        this.flagForCheck = this.profile.type;
      }
    },
  },
  watch: {
    getProfile: function (val) {

      this.corporateClient = this.getProfile.corporateClient;
      if (val) {
        this.$log(val);
        this.setProfile();
        this.getPractices();
      }
    },
    filter: function (val) {
      this.filterValues();
    },
  },

  mounted() {
    var x = {
      0: {
        text: "Carta Identita non legibile",
        document: "4sg233",
      },
      1: {
        text: "Codice Fiscale non legibile",
        document: "4sg233",
      },
    };
    this.setProfile();
    x = JSON.stringify(x);
    this.$log(x);

    if (this.getProfile) {
      this.corporateClient = this.getProfile.corporateClient;
      this.getPractices();
    }

    this.$scrollTo("#app", 700, {
      offset: -75,
    });
  },
  created() {
    this.setProfile();
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "loginerror",
      "isAuthenticated",
      "isProfileLoaded",
      "authStatus",
    ]),
    ...mapState({
      profile: (state) => state.user.profile,
      managedArea: (state) => state.user.profile.type,
      //response: state => `${state.status.response.data}`,
    }),
  },
};
</script>


<style>
@media (min-width: 20px) and (max-width: 767px) {
  .seachMobButton {
    padding: 0 !important;
    height: 30px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pratiche/index.vue